import LegalLayout, { COMPANY } from "./LegalLayout";

export default function Kvkk() {
  return (
    <LegalLayout eyebrow="Yasal Belge" title="Gizlilik ve KVKK Politikası" updated="8 Şubat 2026">
      <p>{COMPANY.legalName} ({COMPANY.brand} markası) olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında <strong>Veri Sorumlusu</strong> sıfatıyla, kişisel verilerinizin işlenmesine ilişkin aydınlatma metnini aşağıda bulabilirsiniz.</p>

      <h2>1. Veri Sorumlusu</h2>
      <ul>
        <li><strong>Unvan:</strong> {COMPANY.legalName}</li>
        <li><strong>Marka:</strong> {COMPANY.brand}</li>
        <li><strong>Adres:</strong> {COMPANY.address}</li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
        <li><strong>E-posta:</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
      </ul>

      <h2>2. İşlenen Kişisel Veri Kategorileri</h2>
      <ul>
        <li><strong>Kimlik verileri:</strong> Ad, soyad</li>
        <li><strong>İletişim verileri:</strong> E-posta, telefon, dükkan adresi</li>
        <li><strong>Müşteri işlem verileri:</strong> Fatura bilgileri, ödeme geçmişi, abonelik durumu</li>
        <li><strong>İşlem güvenliği verileri:</strong> IP adresi, oturum bilgileri, tarayıcı bilgileri, giriş logları</li>
        <li><strong>Ürün/hizmet kullanım verileri:</strong> POS işlemleri, ürün stoğu, müşteri (CRM) verileri — kullanıcıya ait tenant üzerinde depolanan iş verileri</li>
      </ul>

      <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
      <ul>
        <li>{COMPANY.brand} hizmetinin sunulması, sürdürülmesi ve iyileştirilmesi</li>
        <li>Abonelik kaydının oluşturulması, faturalandırma ve ödeme süreçlerinin yürütülmesi</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi (VUK, KVKK, Ticaret Bakanlığı vs.)</li>
        <li>Bilgi güvenliği süreçlerinin yürütülmesi ve saldırı önleme</li>
        <li>Talep ve şikayetlerin yönetilmesi</li>
      </ul>

      <h2>4. Verilerin Aktarıldığı Taraflar</h2>
      <ul>
        <li><strong>PayTR Ödeme Hizmetleri A.Ş.</strong> — Kart ve ödeme işlemleri için (kart verisi bize hiç ulaşmaz; doğrudan PayTR'nun PCI-DSS sertifikalı sanal POS'una gönderilir)</li>
        <li><strong>Resend / e-posta altyapı sağlayıcısı</strong> — İşlemsel e-postalar için</li>
        <li><strong>Bulut altyapı sağlayıcıları</strong> — Verilerin barındırılması amacıyla (AB / TR bölgeleri)</li>
        <li><strong>Yetkili resmi merciler</strong> — Yasal zorunluluk halinde</li>
      </ul>

      <h2>5. Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h2>
      <p>Kişisel verileriniz {COMPANY.brand} platformuna kayıt ve kullanım sırasında, elektronik ortamda otomatik ve otomatik olmayan yollarla, KVKK'nın 5. ve 6. maddelerinde belirtilen sözleşmenin kurulması ve ifası, kanuni yükümlülük, meşru menfaat ve açık rıza hukuki sebeplerine dayanarak işlenmektedir.</p>

      <h2>6. Veri Sahibinin Hakları (KVKK md. 11)</h2>
      <p>KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlendiyse buna ilişkin bilgi talep etme</li>
        <li>İşlenme amacı ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Yurt içinde/dışında aktarıldığı üçüncü kişileri bilme</li>
        <li>Eksik/yanlış işlenmişse düzeltilmesini isteme</li>
        <li>KVKK md. 7'de öngörülen koşullar çerçevesinde silinmesini/yok edilmesini isteme</li>
        <li>Otomatik sistemlerle yapılan analiz sonuçlarına itiraz etme</li>
        <li>Kanuna aykırı işleme nedeniyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
      </ul>

      <h2>7. Başvuru</h2>
      <p>Yukarıdaki haklarınızı kullanmak için taleplerinizi <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> adresine yazılı olarak iletebilir veya {COMPANY.address} adresine posta ile gönderebilirsiniz. Talebiniz KVKK md. 13/2 uyarınca en geç <strong>30 gün</strong> içinde ücretsiz olarak sonuçlandırılır.</p>

      <h2>8. Güvenlik Önlemleri</h2>
      <ul>
        <li>Şifreler tek yönlü hash (bcrypt) ile saklanır; düz metin şifre veri tabanında bulunmaz.</li>
        <li>Sunucu-istemci arası tüm iletişim TLS (HTTPS) üzerinden yapılır.</li>
        <li>Ödeme kart bilgileri hiçbir aşamada {COMPANY.brand} sunucularında saklanmaz — doğrudan PayTR'ya aktarılır.</li>
        <li>Tüm kullanıcı verileri kiracı (tenant) bazında izole edilir; yatay veri sızıntısı mimarisel olarak engellenir.</li>
      </ul>

      <h2>9. Çerez (Cookie) Kullanımı</h2>
      <p>{COMPANY.brand}, temel oturum yönetimi ve tercih hatırlama amacıyla teknik zorunlu çerezler kullanır. İzleme veya reklam amaçlı üçüncü taraf çerezleri kullanılmamaktadır.</p>
    </LegalLayout>
  );
}
